import React, { useEffect, useState } from 'react';

import { Box, Button, Grid, InputAdornment, TextField, Typography } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search';
import ViewListIcon from '@mui/icons-material/ViewList';
import GridViewIcon from '@mui/icons-material/GridView';
import {
    Link,
    useLocation
} from "react-router-dom";
import SearchBGImage from '@assets/images/bgsearch.png';
import TokenCard from '@shared/components/TokenCard';
import { useHistory } from 'react-router-dom';
import { AppContainer } from '@shared/components/AppContainer';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getSearchedTokenAction, tokenSelector } from '@store/slices/token.slice';
import TokenTable from '@shared/components/TokenTable';
import { CustomPagination } from '@shared/components/CustomPagination';
import { Pagination } from '@interfaces/pagination';
import { PAGINATION_LIMIT } from '@shared/constants/app.constant';
import { AppNoToken } from '@shared/components/AppNoToken';
import ExploreIcon from '@mui/icons-material/Explore';
import MagnifierImage from '@assets/images/mdi_magnify.svg';
import { useQuery } from "@shared/helpers/global.helper";

const searchBoxStyles = {
    alignItems: "center",
    justifyContent: "space-between",
    padding: '10px',
    color: "white",
    marginBottom: "20px",
    backgroundImage: `url(${SearchBGImage})`,
    backgroundSize: '100%',
    borderRadius: '10px',
    backgroundRepeat: 'no-repeat',
}
enum ViewType {
    Grid = 'Grid',
    List = 'List'
}

export const SearchTokens = () => {
    let history = useHistory();
    let query = useQuery();
    const tokenSlice = useAppSelector(tokenSelector);
    const dispatch = useAppDispatch();

    const getTokens = (pagination: Pagination) => {
        const title: any = query.get("query");
        if (title && title.length > 0) {
            dispatch(getSearchedTokenAction({ title, pagination }));
        }
    }

    useEffect(() => {
        getTokens({ page: 1, limit: PAGINATION_LIMIT })
    }, [query.get("query")])

    const [searchView, setSearchView] = useState(ViewType.Grid);

    const onChangeView = (view: ViewType) => {
        setSearchView(view);
    }

    const onTokenSelect = (id: number) => {
        // history.push(`public/token/${id}?owned=${false}`)
        history.push(`public/token/${id}`)
    }

    return (
        <AppContainer>
            <Grid container spacing={4}>
                <Grid item md={12}>
                    <Typography variant="h3" align='center' style={searchBoxStyles} sx={{display: {md: 'block', xs: 'none'}}}>
                        <span style={{ fontSize: 'xx-large' }}>Search results for</span> <br /> "{query.get("query")}"
                        <br />
                        <span style={{ fontSize: 'medium' }}>{tokenSlice?.searchedTokens?.data?.length} results</span>
                    </Typography>
                    <Box width="100%" alignItems="center" my={2} display="flex" justifyContent="flex-end">
                        <div className={searchView === ViewType.List ? 'green hover' : 'hover'}> <Box onClick={() => onChangeView(ViewType.List)} display="flex" justifyContent="center"> <ViewListIcon /> &nbsp;&nbsp; <Box mt={0.3}> List View</Box></Box></div>
                        <div className={searchView === ViewType.Grid ? 'green hover' : 'hover'}><Box onClick={() => onChangeView(ViewType.Grid)} display="flex" ml={3} justifyContent="center"> <GridViewIcon className={searchView === ViewType.Grid ? 'green' : ''} /> &nbsp;&nbsp; <Box mt={0.3}> Grid View</Box></Box></div>
                    </Box>
                    {/* <TextField
                        size="small"
                        id="password"
                        className="w-100"
                        placeholder="Search by tokens, locations, clubs, etc."
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    /> */}
                    <Box my={3}></Box>
                    {(searchView === ViewType.List && tokenSlice.searchedTokens?.data?.length > 0) && (
                        <TokenTable rows={tokenSlice?.searchedTokens?.data} />
                    )}
                    {(searchView === ViewType.Grid && tokenSlice.searchedTokens?.data?.length > 0) && (
                        <Grid container spacing={4} >
                            {tokenSlice?.searchedTokens?.data?.map(token => {
                                return (
                                    <Grid item md={4} xs={12}>
                                        <TokenCard token={token} click={onTokenSelect} />
                                    </Grid>
                                )
                            })}
                        </Grid>
                    )}
                    {tokenSlice.searchedTokens?.data?.length > 0 && (
                        <CustomPagination pagination={tokenSlice?.searchedTokens?.meta} change={getTokens} />
                    )}

                    {(!tokenSlice.searchedTokens?.data || tokenSlice.searchedTokens?.data?.length == 0) && (
                      <AppNoToken
                      icon={<img src={MagnifierImage} />}
                      title="This search does not match any Memberships you own" body={'No Membership NFTs with that description can be found. Please try another search.'}>
                      <Box my={3}>
                          <Button size="large" component={Link} to={`/marketplace`} color="primary" variant="contained" >
                              <ExploreIcon /> &nbsp;&nbsp; Explore marketplace
                          </Button>
                      </Box>
                  </AppNoToken>
                    )}

                </Grid>
            </Grid>
        </AppContainer>
    )
}
